import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';
import { Grid2, Typography } from '@mui/material';
import { AlertDialog, CircularIndeterminate } from '@utriper/core-ui';
import Layout from 'components/Layout';
import PriceGroupTabCards from './components/PriceGroupTabCards';
import PriceGroupTabFilters from './components/PriceGroupTabFilters';
import PriceGroupTabForm from '../components/PriceGroupTabForm';
import PriceGroupEmptyState from '../components/PriceGroupEmptyState';
import PriceGroupNoData from '../components/PriceGroupNoData';
import { Section } from '../styles';

const PriceListPage = () => {
    const { t: translate } = useTranslation();
    const { getPriceGroupTabs, handleOpenForm, loading, priceGroupTabs, allPriceGroupTabCount, nameFilterDebounce, pgTabNameFilter, pgTabStatusFilter, pagePgTab, openForm } = usePriceGroupTab();

    useEffect(() => {
        getPriceGroupTabs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameFilterDebounce, pgTabStatusFilter, pagePgTab]);

    return (
        <Layout>
            <Section>
                {/* Title */}
                <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px">
                    <Typography fontSize={20} fontWeight={900} sx={{ color: '#131313' }} noWrap>
                        {translate('price_group_tab.title')}
                    </Typography>
                    <Typography fontSize={16} fontWeight={500} sx={{ color: '#131313bf' }}>
                        {translate('price_group_tab.subtitle')}
                    </Typography>
                </Grid2>

                {/* Filters */}
                <PriceGroupTabFilters />

                {/* Cards */}
                {loading ? <CircularIndeterminate centered /> : priceGroupTabs?.length > 0 ? <PriceGroupTabCards /> : allPriceGroupTabCount <= 0 ? <PriceGroupEmptyState isPriceGroupTab /> : pgTabNameFilter?.length > 0 || pgTabStatusFilter?.length > 0 ? <PriceGroupNoData isPriceGroupTab /> : ''}
            </Section>

            {/* Add Form */}
            <AlertDialog open={openForm} handleClose={() => handleOpenForm()} hideTitle hideActions maxWidth="sm" fullWidth dialogContent={<PriceGroupTabForm />} />
        </Layout>
    );
};

PriceListPage.displayName = 'PriceListPage';

export default PriceListPage;
